import { render, staticRenderFns } from "./PricingEmployeesCompensationPrimaryLayer.vue?vue&type=template&id=ad6cb56c"
import script from "./PricingEmployeesCompensationPrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingEmployeesCompensationPrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports